import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import { shallowEqual, useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { getSource } from 'selectors/offerSelectors'

import { shouldShowGuestPublicRateSignUpCta } from './singlePropertyUtils'

export default function useWalledGarden({ walledGarden, promotion }: App.Property.Property): {
  walledGarden: boolean
  showGuestPublicRateSignUpCta: boolean
} {
  const [isLoggedIn, source] = useAppSelector(state => [
    selectLoggedIn(state),
    getSource(state),
  ], shallowEqual)
  const showGuestPublicRateSignUpCta = shouldShowGuestPublicRateSignUpCta({
    isLoggedIn,
    source,
    isWalledGarden: walledGarden,
  })
  const { isAnyVariant } = useExperiment(ChertoExperiments.sppLoggedOutPricing, {
    canActivate: showGuestPublicRateSignUpCta,
  })

  // Experiment is not applicable.
  if (!showGuestPublicRateSignUpCta) return { walledGarden, showGuestPublicRateSignUpCta: false }

  // Anonymous user is enrolled in the variant.
  if (isAnyVariant) return { walledGarden, showGuestPublicRateSignUpCta: true }

  // Anonymous user is enrolled in the control (or the experiment is off). Note that we need to
  // tighten `walledGarden`'s behaviour to what it was before svc-accommodation#1966 (i.e.
  // `walledGarden` is only `false` if there's an active promotion).
  return { walledGarden: !promotion, showGuestPublicRateSignUpCta: false }
}
